import { createStore } from "vuex";

import auth from "./modules/auth";
import cats from "./modules/categories";
import home from "./modules/home";
import popupLeft from "./modules/popupLeft";
import baseRef from "./modules/baseRef";
import readMore from "./modules/readMore";
import predefAnalyse from "./modules/predefAnalyse";
import leavePopup from "./modules/leavePopup";
import moreInfo from "./modules/moreInfo";
import addBaseRefPopup from "./modules/addBaseRefPopup";
import journey from "./modules/journey";
import powerpoint from "./modules/powerpoint";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    baseRef,
    popupLeft,
    auth,
    cats,
    home,
    readMore,
    predefAnalyse,
    leavePopup,
    moreInfo,
    addBaseRefPopup,
    journey,
    powerpoint,
  },
});
